module.exports = __webpack_public_path__ + "img/12.ee417cb2.png";